export { default } from './PageOrdersEvent.vue'
